// Pure formatting helpers for the settings "Current Plan" card that renders
// GET /api/v2/accounts/subscription/.

import moment from 'moment';

// Subscription statuses that mean the user still has access (mirrors ACTIVE_SUBSCRIPTION_STATUSES
// in customers/services/manage_subscription).
export const ACTIVE_STATUSES = ['active', 'trialing'];

/** Format an ISO date as "August 24 2026 05:53". Returns '' for empty/invalid input. */
export const formatDate = (value) =>
    value && moment(value).isValid() ? moment(value).format('MMMM DD YYYY HH:mm') : '';

/** An item is trialing while it carries a trial_end that is still in the future. */
export const isItemTrialing = (item) =>
    Boolean(item?.trial_end) && moment(item.trial_end).isAfter(moment());

/**
 * Human label for a Stripe billing interval, built from the response's `interval` unit
 * ('day' | 'week' | 'month' | 'year') and `interval_count`. The common cadences get their own
 * wording (monthly / quarterly / annual); everything else falls back to an "every N <unit>" label.
 * Note a trialing subscription reports its trial price here (e.g. day / 14), not the interval it
 * will bill at once the trial ends.
 */
export const intervalLabel = (t, interval, intervalCount) => {
    if (!interval) return '';

    const count = intervalCount || 1;
    const prefix = 'settings.plan_products.interval';

    if (interval === 'month' && count === 1) return t(`${prefix}.monthly`);
    if (interval === 'month' && count === 3) return t(`${prefix}.quarterly`);
    if (interval === 'year' && count === 1) return t(`${prefix}.annual`);
    if (interval === 'week' && count === 1) return t(`${prefix}.weekly`);
    if (interval === 'day' && count === 1) return t(`${prefix}.daily`);

    const genericKeys = {
        day: 'every_days',
        week: 'every_weeks',
        month: 'every_months',
        year: 'every_years',
    };
    const key = genericKeys[interval];
    return key ? t(`${prefix}.${key}`, { n: count }) : '';
};
